/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Title, Tip, Icon, InlineMessage } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './pageheader_styles';



/* ========== ~~~~~~~~~~ PAGE HEADER ~~~~~~~~~~ ========== */
//TODO: Tip label should be dynamic if before 4pm or after 4pm EST - jon
const PageHeader = injectSheet(styles)((props) => {
	const {title, subtitle, dataTip, ignoreDataTip = false, lastUpdatedTimestamp, bannerText, actionButton} = props;
	const formatTipLabel = timestamp => {
        if(!timestamp || timestamp < 0) return '';
		const lastUpdated = new Date(timestamp).toLocaleString('en-US', { timeZone: 'America/Panama' });
		const month = new Date(lastUpdated).toDateString().split(' ')[1];
		const day = new Date(lastUpdated).toDateString().split(' ')[2];
		let time = lastUpdated.split(',')[1];
		time = (time.slice(0,2) + time.slice(9).toLowerCase()).trim();
		return `Data last updated: ${month} ${day} at ${time} EST`;
	};
	const dataAlertBanner = () => <InlineMessage
		name={ignoreDataTip ? 'dataAlertBannerBeta' : 'dataAlertBanner'}
		variant={'system'}
		icon={'exclamation-triangle'}
		message={bannerText}
		display={true}
		close={true}
		handleClose={() => null} />;

	const handleSubTitle = () => subtitle ? <span className={'breadcrumb'}><Icon name={'chevron-right'} animation={'none'} /><span className={'subtitle'}>{subtitle}</span></span> : null;
	return (
		<div className={`${props.classes.pageheader} pageheader`}>
            <Title><h2>{title}{handleSubTitle()}</h2>
			</Title>
			{(dataTip && !ignoreDataTip) && <Tip label={formatTipLabel(lastUpdatedTimestamp ? lastUpdatedTimestamp : null)}
							 content={<div>All data across all reports is updated daily at approximately 4pm EST. All data displayed and available is in EST time zone.</div>} />}
			{bannerText && dataAlertBanner()}
			{actionButton && actionButton}
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default PageHeader;
